// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tabs{border-bottom:1px solid #c4c4c4;width:100vw}", "",{"version":3,"sources":["webpack://./src/components/MainLayout/TabsBar/TabsBar.scss"],"names":[],"mappings":"AAEA,MACI,+BAAA,CACA,WAAA","sourcesContent":["@import '../../../global/styles/variables.scss';\n\n.tabs {\n    border-bottom: 1px solid $lines-gray;\n    width: 100vw;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
